import type { AccessDenial, Intent, SearchPermissionKey } from "@/entities/user"
import { captureError } from "@/shared/lib/diagnostics"
import { showServiceErrorPopup } from "@/shared/lib/platform"
import {
	showAgeGatePopup,
	showAgeMismatchPopup,
	showTrustGatePopup,
} from "./store"

function isSearchPermission(
	permission: AccessDenial["permission"],
): permission is SearchPermissionKey {
	return (
		permission === "easy_match_search" || permission === "social_match_search"
	)
}

export function showAccessDeniedPopup(
	denial: AccessDenial,
	intent: Intent | null,
): void {
	const search = isSearchPermission(denial.permission)
	switch (denial.code) {
		case "age_mismatch":
			showAgeMismatchPopup()
			return
		case "trust_gate":
			// The server sends trust_gate only from search and may omit permission.
			if (search || denial.permission === null) {
				showTrustGatePopup()
				return
			}
			captureError(new Error("trust_gate denial outside search"), {
				scope: "accessDenied.trustGate",
				permission: denial.permission,
			})
			return
		case "age_required":
			if (search) {
				showAgeGatePopup("search", intent)
				return
			}
			showAgeGatePopup("features", intent)
			return
		default: {
			// WS frames are checked against the contract only for a report, so a
			// code the client does not know can still get here.
			denial.code satisfies never
			const error = new Error("Unknown access denial code")
			captureError(error, {
				scope: "accessDenied.unknownCode",
				code: denial.code,
				permission: denial.permission,
			})
			showServiceErrorPopup(error)
		}
	}
}
